/* Copyright 2020 VMware, Inc. All rights reserved. -- VMware Confidential */
namespace platform {
  /**
   * Wrapper for the vuiWizardService, that allows us to add aria-hidden=true to the content in the background
   * before the wizard is opened and to set aria-hidden=false to the background elements once the
   * wizard is destroyed
   */
  angular.module("com.vmware.platform.ui").provider("vxWizardService", [
    () => {
      return {
        $get: (vuiWizardService, hideBackgroundContentService, i18nService) => {
          return (config) => {
            const hiddenElements = hideBackgroundContentService.hideElements();
            config.scope.$on("$destroy", function () {
              hideBackgroundContentService.showElements(hiddenElements);
            });

            if (config["configObjectName"]) {
              if (!config.scope[config.configObjectName].iconClass) {
                config.scope[config.configObjectName].iconClass =
                  "vsphere-icon-bars-line";
                config.scope[
                  config.configObjectName
                ].iconClassAriaLabel = i18nService.getString(
                  "Common",
                  "wizard.steps"
                );
              }
              if (!config.scope[config.configObjectName].closeIconClass) {
                config.scope[config.configObjectName].closeIconClass =
                  "vsphere-icon-times-line";
                config.scope[
                  config.configObjectName
                ].closeIconClassAriaLabel = i18nService.getString(
                  "Common",
                  "close.label"
                );
              }
            }

            return vuiWizardService(config);
          };
        },
      };
    },
  ]);
}
